import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { COLUMNS } from './columns'
import { LoginContext } from '../../../reactcontext/ReactContext'
import axios from 'axios'
import PaymentTable from './PaymentTable'
import { years } from '../../../data/options'

const PaymentTableInit = () => {
  
  const apiUrl = process.env.REACT_APP_API_URL
  const [payments, setPayments] = useState([])
  const [selectedPayments, setSelectedPayments] = useState([])
  const [selectedYear, setSelectedYear] = useState('all')
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(true)
  const { loginInfo } = useContext(LoginContext)
  const navigate = useNavigate()
  const columns = useMemo(() => COLUMNS, [])
  const [refresh, setRefresh] = useState(new Date())


  useEffect(() => {
    if (!loginInfo.login) {
      navigate("/")
    }
  }, [loginInfo, navigate])

  useEffect(() => {
    axios.get(`${apiUrl}/payment/getAllPaymentsWithBalance`, {
      headers: {
        loginToken: localStorage.getItem("loginToken")
      }
    })
    .then(res => {
        if(res.data.error){
            setErrorMessage(res.data.error)
            setPayments([])
            setSelectedPayments([])
        }else{
            setPayments(res.data)
            setSelectedPayments(filterPaymentsByYear(res.data, selectedYear))
        }
        setLoading(false)
    })
    .catch(err => {
        console.log(err)
        setLoading(false)
    })
  }, [apiUrl, selectedYear])

  const filterPaymentsByYear = (paymentsList, year) => {
    if (year === "all") {
      return paymentsList
    }
    return paymentsList.filter(val => {
      const rowYear = val.paymentInit?.year || val.year
      return String(rowYear) === String(year)
    })
  }

  const handleYearChange = (event) => {
    const selectedYearValue = event.target.value;
    setSelectedYear(selectedYearValue)
    setRefresh(new Date())
    setSelectedPayments(filterPaymentsByYear(payments, selectedYearValue))
  };

  return (
    <div className='w-full h-full overflow-auto'>
 
      <div className='p-2 ml-6 rounded-lg'>
        <label>Filter Year: </label>
        <select className='p-1 bg-gray-100' value={selectedYear} onChange={handleYearChange}>
          <option value="all">All Years</option>
          {
            years.map(val => 
              <option key={val} value={String(val)}>{val}</option>
            )
          }
        </select>
      </div>
      <hr />
      {
        loading ? <p className='w-full h-full text-center text-lg py-5'>Fetching data... Please wait</p> :
          payments.length === 0 && (
              <div className='w-full text-center text-lg py-5 gap-y-10 flex flex-col justify-center items-center'>
                <p>{"there are no payments"}</p>
              </div>              
            )
      }

      {
        payments.length > 0 &&  
        <PaymentTable
          refresh={refresh}
          columns={columns} 
          data={selectedPayments} 
          allPayments={payments}
        />
      }
    </div>
  )
}

export default PaymentTableInit
